import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", {
  class: "mb-0",
  style: {"word-break":"break-word !important"}
}, " Tên cấp S/C ", -1)
const _hoisted_2 = {
  class: "mb-0",
  style: {"word-break":"break-word !important"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", {
  class: "mb-0",
  style: {"word-break":"break-word !important"}
}, " D/mục toa xe ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", {
  class: "mb-0 text-end",
  style: {"word-break":"break-word !important"}
}, " S/L vật tư ", -1)
const _hoisted_5 = {
  class: "mb-0 text-end",
  style: {"word-break":"break-word !important"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", {
  class: "mb-0",
  style: {"word-break":"break-word !important"}
}, " Ngày ban hành ", -1)
const _hoisted_7 = {
  class: "mb-0",
  style: {"word-break":"break-word !important"}
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", {
  class: "mb-0",
  style: {"word-break":"break-word !important"}
}, " Mô tả ", -1)
const _hoisted_9 = {
  class: "mb-0",
  style: {"word-break":"break-word !important"}
}
const _hoisted_10 = { class: "d-flex justify-content-center flex-wrap" }

import { PropType } from 'vue';
import { IDinhMucCoDinhNewResponseBase } from '@/core/interfaces/ApiResponses';
import { useButtonCustom } from '@/core/hooks/use-button-custom';
import { useDateTime } from '@/core/hooks/use-date-time-hook';
import { usePagination } from '@/core/hooks/use-pagination';
import { useRouter } from 'vue-router';
import ButtonCustom from '@/components/shared/buttons/ButtonCustom.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DinhMucCoDinhTable',
  props: {
  curPage: {
    type: Number,
    default: 0,
  },
  items: {
    type: Array as PropType<IDinhMucCoDinhNewResponseBase[]>,
    required: true,
  },
  perPage: {
    type: Number,
    default: 0,
  },
  showCapSuaChua: {
    type: Boolean,
    default: true,
  },
  showSoLuongVatTu: {
    type: Boolean,
    default: true,
  }
},
  setup(__props) {



const { indexCal } = usePagination();

const { formatDisplayingDate } = useDateTime();

const { ButtonsType, ButtonTypeColors } = useButtonCustom();

const { push } = useRouter();

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createBlock(_component_el_table, {
    "cell-style": {padding: '0', height: '15px'},
    border: true,
    "empty-text": "Chưa có định mức",
    data: __props.items
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_table_column, {
        label: "STT",
        width: "60"
      }, {
        default: _withCtx((scope) => [
          _createTextVNode(_toDisplayString(_unref(indexCal)(scope.$index, __props.curPage, __props.perPage)), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "ID",
        width: "60"
      }, {
        default: _withCtx((scope) => [
          _createTextVNode(_toDisplayString(scope.row.id), 1)
        ]),
        _: 1
      }),
      (__props.showCapSuaChua)
        ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 0,
            label: "ID",
            width: "190"
          }, {
            header: _withCtx(() => [
              _hoisted_1
            ]),
            default: _withCtx((scope) => [
              _createElementVNode("p", _hoisted_2, _toDisplayString(scope.row.cap_sua_chua.ten_cap_sc || '-'), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_el_table_column, {
        label: "ID",
        width: "150"
      }, {
        header: _withCtx(() => [
          _hoisted_3
        ]),
        default: _withCtx((scope) => [
          _createVNode(_component_router_link, {
            class: "mb-0",
            to: `/quan-ly/danh-muc-toa-xe/${scope.row.id_danh_muc_toa_xe}/chi-tiet/`,
            style: {"word-break":"break-word !important"},
            target: "_blank"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(scope.row.danh_muc_toa_xe.ten_danh_muc), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ]),
        _: 1
      }),
      (__props.showSoLuongVatTu)
        ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 1,
            width: "100"
          }, {
            header: _withCtx(() => [
              _hoisted_4
            ]),
            default: _withCtx((scope) => [
              _createElementVNode("p", _hoisted_5, _toDisplayString(scope.row.vat_tu.length), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_el_table_column, { width: "140" }, {
        header: _withCtx(() => [
          _hoisted_6
        ]),
        default: _withCtx((scope) => [
          _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(formatDisplayingDate)(scope.row.ngay_ban_hanh)), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, null, {
        header: _withCtx(() => [
          _hoisted_8
        ]),
        default: _withCtx((scope) => [
          _createElementVNode("p", _hoisted_9, _toDisplayString(scope.row.mo_ta ?? '-'), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, { width: "50" }, {
        default: _withCtx((scope) => [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(ButtonCustom, {
              "button-type": _unref(ButtonsType).INFO,
              "color-type": _unref(ButtonTypeColors).INFO,
              onClick: ($event: any) => (_unref(push)({
              path: `/quan-ly/dinh-muc-co-dinh/chi-tiet/${scope.row.id}`,
            }))
            }, null, 8, ["button-type", "color-type", "onClick"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["data"]))
}
}

})